import { css } from 'styled-components';
export const weightDefault = css `
  font-weight: 400;
`;
export const weightMedium = css `
  font-weight: 500;
`;
export const headline = css `
  ${weightMedium};
  font-size: 26px;
  line-height: 34px;
`;
export const title = css `
  ${weightMedium};
  font-size: 22px;
  line-height: 30px;
`;
export const titleSub = css `
  ${weightMedium};
  font-size: 18px;
  line-height: 26px;
`;
export const textLarge = css `
  font-size: 16px;
  line-height: 22px;
`;
export const textMedium = css `
  font-size: 14px;
  line-height: 20px;
`;
export const textSmall = css `
  font-size: 12px;
  line-height: 16px;
`;
export const textExtraSmall = css `
  font-size: 10px;
  line-height: 16px;
`;
export default {
    weightDefault,
    weightMedium,
    headline,
    title,
    titleSub,
    textLarge,
    textMedium,
    textSmall,
    textExtraSmall,
};
